import { Action } from '@ngrx/store';

export enum ActionTypes {
  LOGIN_REQUEST = '[Login] Login Request',
  LOGIN_FAILURE = '[Login] Login Failure',
  LOGIN_SUCCESS = '[Login] Login Success',
  LOGOUT_SUCCESS = '[Logout] Logout Success',
  LOGOUT_FAILURE = '[Logout] Logout Failure',
  CONNECTION_REQUEST = '[connection] Request',
  CONNECTION_SUCCESS = '[connection] Success',
  CONNECTION_LOGOUT = '[connection] Logout',
  LOGIN_REQUEST_PREMIUM = '[Login] Login Request Premium',
  LOGIN_SUCCESS_PREMIUM = '[Login] Login Success Premium',
  LOGIN_FAILURE_PREMIUM  = '[Login] Login Failure Premium'
}

export class LoginRequestActionPremium implements Action {
  readonly type = ActionTypes.LOGIN_REQUEST_PREMIUM;
}

export class LoginRequestAction implements Action {
  readonly type = ActionTypes.LOGIN_REQUEST;
}

export class LoginFailureAction implements Action {
  readonly type = ActionTypes.LOGIN_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class LoginSuccessActionPremium implements Action {
  readonly type = ActionTypes.LOGIN_SUCCESS_PREMIUM;
  constructor(public payload:any) {}
} 

export class LoginFailureActionPremium implements Action {
  readonly type = ActionTypes.LOGIN_FAILURE_PREMIUM;
  constructor(public payload:any) {}
} 


export class LoginSuccessAction implements Action {
  readonly type = ActionTypes.LOGIN_SUCCESS;
  constructor(public payload:any) {}
}

export class LogoutSuccessAction implements Action{
  readonly type = ActionTypes.LOGOUT_SUCCESS;
}

export class LogoutFailureAction implements Action{
  readonly type = ActionTypes.LOGOUT_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class ConnectionRequestAction implements Action {
  readonly type = ActionTypes.CONNECTION_REQUEST;
}

export class ConnectionSucessAction implements Action {
  readonly type = ActionTypes.CONNECTION_SUCCESS;
  constructor(public payload: any) {}
}

export class ConnectionLogoutAction implements Action{
  readonly type = ActionTypes.CONNECTION_LOGOUT;
}


export type Actions = LoginRequestAction | LoginFailureAction | LoginSuccessAction | LogoutSuccessAction | LogoutFailureAction | ConnectionRequestAction | ConnectionSucessAction | ConnectionLogoutAction | LoginSuccessActionPremium |LoginRequestActionPremium | LoginFailureActionPremium;